import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Line from '../../../../../common/chart/chartContainer/Line'
import { Icon } from '../../../../../common/html/icon'
import { Tooltip } from '../../../../../common/tooltip'
import { formatVal } from '../../../../../helpers/value'
import CustomizedLabelLine from '../../common/CustomizedLabelLine'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { TREND_CHARTS } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ isDynamicReport, id, check = [], isDownloadComponent }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)

  const charts = TREND_CHARTS.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  })).filter(({ value }) => !isDynamicReport || check.includes(value))

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const isH100 = charts?.length >= 3

  return (
    <div
      style={{
        height: isDownloadComponent
          ? '100%'
          : getStyleHeightContainer(
              isDynamicReport,
              isNoData,
              isH100 ? 332 : 332 / 2,
            ),
      }}
      className={classes.coverageTrendContainer}
    >
      {charts.map((chart, idx) => {
        return (
          <div
            key={idx}
            className={`${isH100 ? 'h50' : 'h100'} w50 flexColumn ${
              classes.chart
            }`}
          >
            <div className="fw600 dFlex alignItemsCenter">
              {chart.title}
              {!isDynamicReport && !isDownloadComponent && (
                <Tooltip tooltipContent={chart.tooltipContent}>
                  <Icon
                    className="icon-info-circle ml1"
                    style={{ color: '#9C9C9C' }}
                  />
                </Tooltip>
              )}
            </div>
            <div className="h100 pt1">
              <ChartContainer
                data={dataByTrend}
                margin={{
                  top: 16,
                  left: 10,
                  bottom: 0,
                  right: 10,
                }}
                width="100%"
                height="100%"
                xAxis={[
                  {
                    dataKey: 'year',
                    padding: { left: 15, right: 15 },
                    tickMargin: 3,
                    height: 18,
                  },
                ]}
                yAxis={[
                  {
                    yAxisId: 'left',
                    dataKeys: [chart.value],
                    isLineChart: true,
                    hide: true,
                  },
                ]}
                tooltip={{
                  schema: {
                    content: [
                      {
                        dataKey: chart.value,
                        label: chart.title,
                        formatValue: (value) => formatVal(value, locale),
                      },
                    ],
                  },
                }}
              >
                <Line
                  yAxisId={'left'}
                  dataKey={chart.value}
                  stroke={chart.color}
                  label={
                    <CustomizedLabelLine
                      formatValue={(value) => formatVal(value, locale)}
                    />
                  }
                />
              </ChartContainer>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Trend
